export const MarketInformationProductList =
  'https://docs.google.com/forms/d/e/1FAIpQLSe5zuu1RPwzQwLiysVCPOfkyhPbaSXhfrJBUHJ6GyN5R21zYw/viewform';
export const DEFAULT_THUMBNAIL_URL =
  'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/my-data-page/dp-01.svg';
export const DASHBOARD_URL = __STAGING__
  ? 'https://dashing.sourcesage.co'
  : 'https://dashboard.sourcesage.co';



// WEBPACK FOOTER //
// ./app/constants/URL.ts